/**
 * Teams (Equipes) API Module
 * @module api/teams
 */
import { apiRequest } from './core.js';

export const teamAPI = {
  // CRUD
  getAll: (params = {}) => {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`/teams${qs ? '?' + qs : ''}`);
  },
  getById: (id) => apiRequest(`/teams/${id}`),
  create: (team) => apiRequest('/teams', {
    method: 'POST',
    body: JSON.stringify(team),
  }),
  update: (id, team) => apiRequest(`/teams/${id}`, {
    method: 'PUT',
    body: JSON.stringify(team),
  }),
  delete: (id) => apiRequest(`/teams/${id}`, {
    method: 'DELETE',
  }),

  // Members
  addMember: (teamId, member) => apiRequest(`/teams/${teamId}/members`, {
    method: 'POST',
    body: JSON.stringify(member),
  }),
  removeMember: (teamId, memberId) => apiRequest(`/teams/${teamId}/members/${memberId}`, {
    method: 'DELETE',
  }),
  getMemberHistory: (teamId) => apiRequest(`/teams/${teamId}/members/history`),

  // KPIs & Comparison
  getKPIs: (teamId, period = 'month') => apiRequest(`/teams/${teamId}/kpis?period=${period}`),
  compare: (teamIds, period = 'month') => apiRequest(`/teams/compare?team_ids=${teamIds.join(',')}&period=${period}`),
  getStats: () => apiRequest('/teams/stats'),
};
